/** TopicPage
 * The purpose of this component is to do the following:
 * -- Check to see if user is authenticated
 * -- Load page when corresponding route is hit by user /content/browse/<topic slug>/
 * -- Determine if there should be a content request using either outline or card shape
 * -- Render <BrowseLayout/> component
 */

import { isUndefined } from "@s-libs/micro-dash";
import { useRouter } from "next/router";

import BrowseLayout from "@/browse/BrowseLayout/BrowseLayout";
import { useContent } from "@/content/useContent/useContent";
import ErrorMessage from "@/errors/ErrorMessage";
import NotLoggedInError from "@/errors/NotLoggedInError";
import useUser from "@/users/useUser";
const TopicPage = () => {
  const {
    asPath,
    query: { contentId },
  } = useRouter() || { query: { route: "" } };

  const isSingleTopic = /browse-type=single/.test(asPath);

  if (isUndefined(contentId)) return;

  const reqMemberLimit = isSingleTopic ? 50 : 25;
  const reqShape = isSingleTopic ? "card" : "outline";
  const reqDepth = isSingleTopic ? 1 : 2;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data: user } = useUser();
  const {
    data: content,
    error,
    loading,
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = useContent(
    contentId,
    // Query Params for Topic Page - Query for Outline or Card
    {
      depth: reqDepth,
      member_limit: reqMemberLimit,
      shape: reqShape,
      use_imgix: true,
    },
  );

  // Authenticate users - Temporary until dismissible Sign In Modal is created
  if (!user?.is_authenticated) {
    return <NotLoggedInError />;
  }

  // Response Error Handling
  if (error) {
    return (
      <ErrorMessage headline="Oh no, something went wrong.">
        <p>Either you do not have access, or an error has occurred.</p>
        <sub>{error?.message}</sub>
      </ErrorMessage>
    );
  }

  return (
    <BrowseLayout
      content={content}
      contentId={contentId}
      error={error}
      isSingleTopic={isSingleTopic}
      loading={loading}
    />
  );
};

export default TopicPage;
